import { Modal } from "@mui/material";
import { ReactNode } from "react";
import styles from "./gartner-free-trial-base-modal.styles.module.scss";
import { TypographyComponent } from "../../../../gravity/typography/typography.component";
import { CloseIcon } from "../../../../../icons/close.icon";
import { IconButtonComponent } from "../../../../gravity/buttons/icon-button/icon-button.component";
import { PrimaryButtonComponent } from "../../../../gravity/buttons/primary/primary-button.component";
import { TertiaryButtonComponent } from "../../../../gravity/buttons/tertiary/tertiary-button.component";
import { TertiaryButtonTheme } from "../../../../gravity/buttons/button.constants";
import { t } from "i18next";

type FreeTrialBaseModalProps = {
  open: boolean;
  onClose: () => void;
  onCTAClick: () => void;
  title: string;
  children: ReactNode;
  actionButtonText: string;
  showCancelFooterButton?: boolean;
  isCTADisabled?: boolean;
};

export const FreeTrialBaseModal = ({
  open,
  onClose,
  onCTAClick,
  title,
  children,
  actionButtonText,
  showCancelFooterButton = false,
  isCTADisabled = false,
}: FreeTrialBaseModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-label={title}
    >
      <div className={styles.overlay}>
        <div className={styles.contentContainer}>
          <div className={styles.closeButton}>
            <IconButtonComponent onClick={onClose} ariaLabel="close">
              <CloseIcon />
            </IconButtonComponent>
          </div>
          <div className={styles.header}>
            <div>
              <TypographyComponent styling={"h3"} boldness={"regular"} rootClassName={styles.title}>
                {title}
              </TypographyComponent>
            </div>
          </div>
          <div className={styles.body}>
            {children}
          </div>
          <div className={styles.footer}>
            <div className={styles.buttonGroup}>
              {showCancelFooterButton && (
                <TertiaryButtonComponent onClick={onClose} rootClassName={styles.cancelButton} theme={TertiaryButtonTheme.GREY}>
                  {t("Cancel")}
                </TertiaryButtonComponent>
              )}
              <PrimaryButtonComponent
                onClick={onCTAClick}
                isDisabled={isCTADisabled}
              >
                {actionButtonText}
              </PrimaryButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};